module.exports = __webpack_public_path__ + "img/customer-bg.c10d14bd.png";